import { HttpClient } from 'common/services/http-client.service';

import dataManagementApiConfig from './data-management.config';
import { PagedRequest } from 'common/models/data/pagedRequest.model';
import {
    CompanyInfoDTO,
    DataManagementDetails,
    LocationDetails,
    UpdateCompanyInfoPayload
} from '../models/data-management.model';
import { ApiResult } from 'common/models';
import { IErrorApiResponse } from 'common/models/api-service/error-response.model';

export class DataManagementService extends HttpClient {
    public static async getCompanyFootprints(
        payload: PagedRequest
    ): Promise<ApiResult<DataManagementDetails | IErrorApiResponse> | undefined> {
        return DataManagementService.invokeApi<DataManagementDetails | IErrorApiResponse>(
            dataManagementApiConfig.fetchAllCompanyFootprintLocations(payload)
        );
    }

    public static async getCompanyInfo(): Promise<ApiResult<CompanyInfoDTO> | undefined> {
        return this.invokeApi(dataManagementApiConfig.fetchCompanyInfo());
    }

    public static async updateCompanyInfo(
        payload: UpdateCompanyInfoPayload
    ): Promise<ApiResult<boolean> | undefined> {
        return await this.invokeApi(dataManagementApiConfig.updateCompanyInfo(payload));
    }

    public static async updateLocationWiseCompanyFootprint(payload: LocationDetails) {
        return await this.invokeApi(
            dataManagementApiConfig.updateLocationWiseCompanyFootprint(payload)
        );
    }
}
